import React from 'react'
import { Text, View, useStyles } from '@ion-ui/core'
import { useMediaQuery } from 'react-responsive'
import CounterCard from '../Cards/CounterCard'
import { Styles } from './styles'

const items = [{
  number: '1090 ',
  amount: '',
  title: 'Sueños de vivienda cumplidos'
},
{
  number: '+$3500 ',
  amount: 'MDP',
  title: 'En financiamiento para personas'
},
{
  number: '+10 ',
  amount: 'mil',
  title: 'Viviendas financiadas en México... ¡y las que faltan!'
},
{
  number: '+$15 ',
  amount: 'mil MDP',
  title: 'En casas y negocios que se están construyendo para alguien como tú'
}]

const WhySection = () => {
  const styles = useStyles(Styles)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <View variant='section' css={styles.sectionContainer}>
      <View css={styles.wrapper}>
        <Text variant={isMobile ? 'h5' : 'h4'} css={styles.title}>¿Por qué ION?</Text>
      </View>
      <View css={styles.containerCards}>
        {items.map((item, i) => <CounterCard key={item + '_' + i} {...item} />)}
      </View>
      <hr css={styles.hr} />
    </View>
  )
}

export default WhySection
